import axios from 'axios'
import Config from '../../config'

const { restful } = Config

export interface CarRequestResponse {
  id: number
  request_status: string
  renter_name: string
  renter_email: string
  renter_phone: string
  preferred_brand: string | null
  preferred_model: string | null
  preferred_location: string | null
  car_information: {
    model_year?: string
    price_per_month?: number
    currency?: string
    duration?: string
    duration_type?: string
    pickup_date?: string
    drop_off_date?: string
  } | null
  notes: string | null
  created_at: Date
  updated_at: Date
}

export const getCarRequestById = async (
  requestId: number | string,
): Promise<CarRequestResponse | null> => {
  try {
    const response = await axios.get(`${restful.URL}/car-request/${requestId}`, {
      headers: {
        project: 'haup-stable',
      },
    })

    if (!response.data.result || !response.data.data) {
      return null
    }

    return response.data.data
  } catch (error) {
    console.error('Error fetching car request:', error)
    return null
  }
}

export const getCarRequestByBrandAndModel = async (
  brand: string,
  model: string,
): Promise<CarRequestResponse | null> => {
  try {
    const response = await axios.get(`${restful.URL}/car-request/search`, {
      params: {
        brand,
        model,
      },
      headers: {
        project: 'haup-stable',
      },
    })

    if (!response.data.result || !response.data.data) {
      return null
    }

    return response.data.data
  } catch (error) {
    console.error('Error fetching car request:', error)
    return null
  }
}
